import { QueryClientProvider } from '@tanstack/react-query'
import React, { ReactNode } from 'react'
import { queryClient } from './queryClient'

interface QueryClientWrapperProps {
  children: ReactNode
}

const QueryClientWrapper = ({ children }: QueryClientWrapperProps) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export default QueryClientWrapper
